{
  "columns": {
    "column": "Колонка",
    "actions": "Действия",
    "resetWidths": "Сбросить ширины колонок",
    "resetSorting": "Сбросить сортировку",
    "pin": {
      "title": "Закрепить",
      "left": "Закрепить слева",
      "pinnedLeft": "Закреплено слева",
      "right": "Закрепить справа",
      "pinnedRight": "Закреплено справа"
    },
    "unpin": {
      "title": "Открепить",
      "unpinned": "Откреплено",
      "left": "Открепить слева",
      "right": "Открепить справа",
      "all": "Открепить все"
    },
    "showAll": "Показать все колонки",
    "hideAll": "Скрыть все колонки",
    "hide": "Скрыть",
    "visibility": "Видимость",
    "reset": "Сбросить настройки"
  },
  "general": {
    "autoResize": "Авторазмер колонок"
  },
  "loadMore": "Загрузить больше"
}